import React from "react";
import { getAppsmithConfigs } from "ee/configs";
import {
  default as CE_EmbedSnippetTab,
  AppSettings,
  ShareModal,
} from "ce/pages/Applications/EmbedSnippetTab";
import { getIsAiAgentApp } from "ee/selectors/aiAgentSelectors";
import { useSelector } from "react-redux";
export * from "ce/pages/Applications/EmbedSnippetTab";

const { cloudHosting } = getAppsmithConfigs();

interface EmbedSnippetTabProps
  extends React.ComponentProps<typeof CE_EmbedSnippetTab> {
  isAppSettings?: boolean;
}

export function EmbedSnippetTab(props: EmbedSnippetTabProps) {
  const { isAppSettings } = props;
  const isAiAgentApp = useSelector(getIsAiAgentApp);

  if (cloudHosting && !isAiAgentApp) {
    return <CE_EmbedSnippetTab {...props} />;
  }

  if (isAppSettings) return <AppSettings />;

  return <ShareModal />;
}

export default EmbedSnippetTab;
